import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Hero from '../Hero/Hero';
import Hero3 from '../Hero3/Hero3';
import Hero2 from '../Hero2/Hero2';
import ArticleCol from '../AritcleCol/ArticleCol.js';
import ArticleRow from '../ArticleRow/ArticleRow.js';
import HeaderSmall from '../HeaderSmall/HeaderSmall';
import serverUrl from '../../constants/serverUrl';


const blurb = `
We are the hygiene solution specialists, dedicated to creating a world
wherepeople can enjoy their environments with peace of mind 
knowing they are safe, clean and healthy.
`;

class About extends Component {
  
  render() {
    const { posts, products } = this.props;
    const aboutus = posts.find(p => p.name === 'aboutus');
    const aboutusmain = posts.find(p => p.name === 'aboutusmain')
    const aboutus1 = posts.find(p => p.name === 'aboutus1');
    const aboutus2 = posts.find(p => p.name === 'aboutus2');
    const postbottom1 = posts.find(p => p.name === 'homebottom1');
    const postbottom2 = posts.find(p => p.name === 'homebottom2');

    
    if(!aboutus) {
      return <div/>
    }
    const aboutus1Img = serverUrl + aboutus1.image;
    return (
      <div>
        <div style={{ top: '0px', zIndex: '1000', width: '100%'}}  className='d-none d-md-block '>
          <HeaderSmall title="Our Products" />
        </div>
          <Hero3
            titleClass={'smaller-title'}
            title={'About Us'}
            subtitle={aboutusmain.content}
            subtitleClass={'smaller-subtitle'}
            imgClass={'hero-image-about'}
            img={aboutusmain.image}
          />
        <div className="container py-4">
          <div className="row g-4 py-4">
              <div className="col col-12 pt-2">
                <a href="/our_products/1" style={{'text-decoration': 'none'}}>
                  <h1 className='hero-subtitle'>Our Products</h1>
                </a>
              </div>
              <a href="/our_products/1">
                <div class="col-12 pt-4 d-flex justify-content-center">
                  <img src={serverUrl + aboutus.image} style={{width: '95%'}} />
                </div>
              </a>
          </div>
          <div className="row g-4 py-4"></div>
          <div className="row g-4 py-4"></div>
        </div>
        <Hero3
          title={aboutus2.title}
          titleClass={'smaller-title'}
          subtitle={aboutus2.content}
          
          subtitleClass={'smaller-subtitle'}
          imgClass={'hero-image-about-2'}
          img={aboutus2.image}
        />
        <div className="container py-4">
          <div className="row g-4">
              <div className="col col-md-6 col-lg-6 col-xs-12 pt-2">
                <img src={aboutus1Img} 
                  alt={aboutus1.title} className="middleimg"
                  style={{width: '100%', height: 'auto'}}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-6 col-xs-12 pt-2">
                <ArticleCol title={aboutus1.title} body={aboutus1.content} id={aboutus1.id} link={aboutus1.linkURL} />
              </div>
          </div>
        </div>
        <div className="bg-gray-100">
          <div className="container py-4">
            <div className="row g-4">
              <div className="col col-md-6 col-lg-6 col-xs-12 pt-2">
                <ArticleRow isHTMLBody={true} title={postbottom1.title} image={postbottom1.image}
                id={postbottom1.id} link={postbottom1.linkURL}
                  body={postbottom1.content} titleColor={'#FFFFFF'} bgColor={'#32c8d4'} pColor={'#000000'} linkColor={'#FFFFFF'}
                />
              </div>
              <div className="col col-md-6 col-lg-6 col-xs-12 pt-2">
                <ArticleRow isHTMLBody={true} title={postbottom2.title} image={postbottom2.image} body={postbottom2.content}
                  id={postbottom2.id} link={postbottom2.linkURL}
                  titleColor={'#32c8d4'} bgColor={'#5a2684'} pColor={'#FFFFFF'} linkColor={'#32c8d4'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default withRouter(About);



// WEBPACK FOOTER //
// src/components/pages/About.js